<template>
    <div class="product-container">
      <div style="position:fixed;top:0;left:0;right:0;background-color:#fff;z-index:10;">
        <div style="height:40px;border-bottom:1px solid #eee;">
          <a style="float:left;"><</a>
          <div style="display:flex;align-items:center;justify-content:center;margin-right:16px;">
            <a @click="toggleInfo('main')" style="color: #6d6d6d;text-decoration: none;">商品</a>
            <a @click="toggleInfo('main')" style="color: #6d6d6d;text-decoration: none;height:40px;line-height:40px;border-bottom:1px solid #2dbae7;margin: 0 22px;">详情</a>
            <a @click="toggleInfo('main')" style="color: #6d6d6d;text-decoration: none;">评论</a>
          </div>
        </div>
        <div class="feature-spec" v-show="showInfo!='main'" style="height:50px;border-bottom:1px solid #eee;display:flex;align-items:center;justify-content:space-around;">
          <a @click="toggleInfo('feature')" :class="showInfo=='feature'?'active':''" style="color: #6d6d6d;text-decoration: none;">产品介绍</a>
          <a @click="toggleInfo('spec')" :class="showInfo=='spec'?'active':''" style="color: #6d6d6d;text-decoration: none;">规格参数</a>
          <a @click="toggleInfo('compare')" :class="showInfo=='compare'?'active':''" style="color: #6d6d6d;text-decoration: none;">产品比较</a>
        </div>
      </div>
        <!--<div class="p-top"></div>-->
        <div class="p-zone">
          <scroller :on-refresh="refresh" :on-infinite="infinite" ref="myscroller">
            <div v-show="showInfo=='main'" class="p-detail">
                <div class="d-swiper">
                    <swiper :options="swiperOption" not-next-tick="true" ref="mySwiper">
                      <template v-for='item in swiperImgs'>
                        <swiper-slide>
                          <img :src="BASE_URL+item.images">
                        </swiper-slide>
                      </template>
                      <div class="swiper-pagination" slot="pagination"></div>
                      <div class="swiper-scrollbar" slot="scrollbar"></div>
                    </swiper>
                </div>
                <!--<div class="d-notice">-->
                    <!--<p>618索粉大狂欢</p>-->
                    <!--<p>-->
                        <!--<img src="../assets/image/hourglass.png">-->
                        <!--距离结束<span>01天02时3分23秒</span>-->
                    <!--</p>-->
                <!--</div>-->
                <div class="d-desc">
                    <p class="desc-title">
                        <!--<span class="icon i-new">新品</span>-->
                        <span v-show='salestatus!="NORMALSALE"' class="icon i-promotion">促销</span>
                        <span v-show='storestatus=="NOSTOCK"' class="icon i-soldout">缺货</span>
                        {{cnName}}
                    </p>
                    <!--<p class="desc-more">很逗面熟和怒,动,描述,把音量从咸菜的束缚中解放出来</p>-->
                </div>
                <div class="d-price">
                    <p class="p-basic">
                        <span class="p-left">价格</span>
                        <span class="p-right">RMB {{srp}}</span>
                    </p>
                    <div v-show='memberpriceflag==1&&price' class="p-actual">
                        <p>
                            <span class="p-left">尊享价</span>
                            <span class="p-right">RMB {{price}}</span>
                        </p>
                        <p v-show='memberpriceflag==1&&pts' class="grow-num">可获约{{pts}}倍成长值</p>
                    </div>
                    <div v-show='!token&&memberpriceflag==1' class="login-btn"  @click="ssologin">
                        <a>立即登录</a>登录即享会员尊享价
                    </div>
                </div>
                <div class="d-selected">
                    <div class="selected-l">已选</div>
                    <div class="selected-r">
                        <div class="r-img" @click="selectBundle">
                            <p>{{categoryEnName}}</p>
                            <p>颜色 : {{color}}</p>
                            <p>数量: 1件</p>
                        </div>
                        <div :class="[collapse[0].collapsed?'on':'','suit-foc']">
                            <h3 @click="toggleCollapse('suit')">
                                套装详情
                                <img src="../assets/image/chevron_down.png">
                            </h3>
                            <p v-if='!collapse[0].collapsed&&suit[0]'>{{suit[0].des}}</p>
                          <div v-show='collapse[0].collapsed' class="detail">
                            <template v-for='s in suit'>
                            <template v-for='item in s.items'>
                              <div class="s1">
                                <template v-if='item.eightd'>
                                  <router-link :to='{path:"/Product",query:{eightD:item.eightd}}'>
                                    <div class="img-div">
                                      <img :src='BASE_URL+item.image'>
                                    </div>
                                  </router-link>
                                  <p>{{item.title}}</p>
                                </template>
                                <template v-else>
                                  <div class="img-div">
                                    <img :src='BASE_URL+item.image'>
                                  </div>
                                  <p>{{item.title}}</p>
                                </template>
                              </div>
                              <div v-for='i in item.items'>
                                <template v-if='i.eightd'>
                                  <router-link :to='{path:"/Product",query:{eightD:i.eightd}}'>
                                  <div class="img-div">
                                    <img :src='BASE_URL+i.image'>
                                  </div>
                                  </router-link>
                                  <p>{{i.vtitle}}</p>
                                </template>
                                <template v-else>
                                  <div class="img-div">
                                    <img :src='BASE_URL+i.image'>
                                  </div>
                                  <p>{{i.vtitle}}</p>
                                </template>
                              </div>
                            </template>
                            </template>
                          </div>
                        </div>
                        <div :class="[collapse[1].collapsed?'on':'','suit-foc']">
                            <h3 @click="toggleCollapse('foc')">
                                赠品详情
                                <img src="../assets/image/chevron_up.png">
                            </h3>
                            <p v-show='!collapse[1].collapsed'>
                              <template v-for='(item,index) in foc'><span v-if='index!=0'>,</span>{{item.title}}</template>
                            </p>
                          <div v-show='collapse[1].collapsed' class="detail">
                            <div v-for='item in foc'>
                              <div class="img-div">
                                <img :src='BASE_URL+item.image'>
                              </div>
                              <p>{{item.title}}</p>
                            </div>
                          </div>
                        </div>
                    </div>
                </div>
                <div v-show='promotelist||cartpromotelist' class="d-promotion">
                    <div class="promotion-l">促销</div>
                    <div class="promotion-r">
                      <p v-for='item in cartpromotelist'>
                        <span>[{{promotionTitle(item.promotiontype)}}]</span>
                        {{item.promotiondesc}}
                      </p>
                      <p v-for='item in promotelist'>
                        <span>[{{promotionTitle(item.promotiontype)}}]</span>
                        {{item.promotiondesc}}
                      </p>
                    </div>
                    <img src="../assets/image/more.png">
                </div>
                <div class="d-about">
                    <div>
                        <img src="../assets/image/about-location.png">
                        <p>配送说明</p>
                    </div>
                    <div>
                        <img src="../assets/image/about-user.png">
                        <p>线下体验</p>
                    </div>
                    <div>
                        <img src="../assets/image/about-edit.png">
                        <p>产品注册</p>
                    </div>
                    <div>
                        <img src="../assets/image/about-star.png">
                        <p>特色活动</p>
                    </div>
                </div>
                <div class="d-comments">
                    <div class="c-head">
                        <p class="c-p1">商品评论({{totalCount}})</p>
                        <p class="c-p2">好评度<span>{{averageRating}}</span></p>
                        <!--<p class="c-p3">-->
                            <!--<span>我要评论</span>-->
                            <!--<img src="../assets/image/message.png">-->
                        <!--</p>-->
                    </div>
                    <template v-for='review in reviews'>
                      <comment-component :review='review'></comment-component>
                    </template>
                    <div @click="goAllComment" class="all-comment">查看全部评论 ></div>
                </div>
                <div v-show='recommend' class="d-recommend">
                    <p>推荐商品</p>
                    <div class="recommend-list">
                      <div v-for='item in recommendList' class="recommend-item">
                        <router-link :to='{path:"/Product",query:{eightD:item.fitting8D}}'>
                          <div class="re-img">
                            <img :src='BASE_URL+item.imagePath'>
                          </div>
                          <p class="re-name">{{item.enName}}</p>
                          <!--<p class="re-price">RMB {{item.price}}</p>-->
                        </router-link>
                      </div>

                    </div>
                </div>
            </div>
            <div v-show="showInfo=='feature'" class="p-feature">
              <iframe id="iframe" @load="getIframeHeight" width="100%" frameborder="0" :src="feature"/>
            </div>
            <div class="p-spec" v-show="showInfo=='spec'">
              <template v-for="spec in mainSpec" >
                <div class="spec-title">{{spec.cnName}}</div>
                <div v-for="item in spec.specleveltwos" class="spec-list">
                  <p>{{item.cnName}}</p>
                  <p>{{item.value}}</p>
                </div>
              </template>
            </div>
          </scroller>
        </div>
      <div v-show='isShowAddBasket'>
        <div @click="showAddBasket" class="bg-gray"></div>
        <div class="product-add">
          <div class="add-head">
            <div class="head-img"><img :src="BASE_URL+imagePath"></div>
            <div class="head-title">
              <p class="cname">{{cnName}}</p>
              <p class="price">价格 RMB 2699<span>x{{quantity}}</span></p>
            </div>
          </div>
          <div v-show='foc' class="add-foc">
            <p class="foc-title">赠品</p>
            <div class="foc-content">
              <div v-for='item in foc' class="foc-item">
                <div class="foc-img">
                  <img :src="BASE_URL+item.image">
                </div>
                <p class="foc-name">{{item.title}}</p>
              </div>
            </div>
          </div>
          <div @click="addBasket" class="add-sure">确认</div>
        </div>
      </div>

        <div v-show='showSelectBundle' class="product-bundle">
          <div @click="selectBundle" class="bg-gray"></div>
          <div class="bundle-zone">
            <div class="b-head">
              <img class="head-img" :src="BASE_URL+imagePath">
              <div class="head-info">
                <p class="i-name">{{categoryCnName}}</p>
                <p class="i-title">尊享价:</p>
                <p class="i-price"><img src="../assets/image/product/wish.png">RMB 1799</p>
              </div>
            </div>
            <div class="b-content">
              <p class="c-title">规格</p>
              <div class="c-options single">
                <div @click="getBundle(item.eightd)" v-for='item in specifications' v-if='!item.suits' :class="[selectdBundle.eightd==item.eightd?'active':'','option-item']">
                  <p class="o-title">{{item.title}}</p>
                </div>
              </div>
              <div class="c-options bundle">
                <div @click="getBundle(item.eightd)" v-for='item in specifications' v-if='item.suits' :class="[selectdBundle.eightd==item.eightd?'active':'','option-item']">
                  <p class="o-title">{{item.title}}</p>
                  <div class="o-img">
                    <div v-for='suit in item.suits'>
                      <img :src="BASE_URL+suit.image">
                      <p>{{suit.title}}</p>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div class="b-content">
              <p class="c-title">颜色</p>
              <div class="c-options">
                <div @click="getColor(item.sku8D)" :class="[item.sku8D==eightD?'active':'','option-item']" v-for='item in colorList'>
                  <p class="o-title">{{item.color}}</p>
                </div>
              </div>
            </div>
            <div class="b-content">
              <p class="c-title">数量</p>
              <div class="input-div">
                <div class="decrease" @click="changeQuantity(quantity/1-1)">-</div>
                <input type="number" v-model="quantity">
                <div class="increase" @click="changeQuantity(quantity/1+1)">+</div>
              </div>
            </div>
            <div @click="ensureBundle" class="b-btn">确认</div>
          </div>
        </div>
        <div class="p-bottom">
          <div @click="addWishList" class="b-smallbtn">
            <img src="../assets/image/product/wish.png">
            <p>心愿单</p>
          </div>
          <div @click="goCart" class="b-smallbtn">
            <img src="../assets/image/product/cart.png">
            <p>购物车</p>
          </div>
          <div class="b-btn">
            <p @click="showAddBasket" v-if='storestatus=="INSTOCK"&&salestatus=="NORMALSALE"'>加入购物车</p>
            <p @click="showAddBasket" v-if='salestatus=="PRESALES"'>在线预订</p>
            <p style="background-color:#8f8f8f;" v-if='storestatus=="NOSTOCK"||salestatus=="STOPONLINE"'>在线售罄</p>
          </div>
        </div>
    </div>
</template>
<style lang="less" scoped>
@fontColor: #585858;
@blue: #0a83d7;
.feature-spec .active {
  color: #2dbae7 !important;
}
.product-add {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #ffffff;
  z-index: 888;
  .add-head {
    padding: 20px 0 20px 100px;
    margin: 0 20px;
    border-bottom: 1px solid #9f9f9f;
    position: relative;
    .head-img {
      position: absolute;
      left: 0;
      top: 20px;
      width: 80px;
      height: 80px;
      border: 1px solid #9f9f9f;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        max-width: 90%;
        max-height: 90%;
      }
    }
    .head-title {
      color: @fontColor;
      height: 80px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-between;
      .cname {
        font-size: 14px;
      }
      .price {
        span {
          color: @blue;
          position: absolute;
          right: 0;
          bottom: 20px;
        }
      }
    }
  }
  .add-foc {
    padding: 20px;
    .foc-title {
      font-size: 14px;
      color: @fontColor;
      margin-bottom: 12px;
    }
    .foc-content {
      color: #999999;
      font-size: 10px;
      display: flex;
      .foc-item {
        width: 75px;
        margin-right: 10px;
        .foc-img {
          height: 75px;
          border: 1px solid #9f9f9f;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            width: 95%;
          }
        }
        .foc-name {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
  .add-sure {
    width: 100%;
    height: 45px;
    line-height: 45px;
    text-align: center;
    background-color: @blue;
    color: #ffffff;
    font-size: 16px;
  }
}
.product-bundle {
  .bundle-zone {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 8%;
    right: 0;
    background-color: #ffffff;
    z-index: 888;
    overflow-y: scroll;
    .b-head {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      padding: 60px 18px 30px 18px;
      .head-img {
        width: 75px;
        margin-right: 20px;
      }
      .head-info {
        .i-name {
          font-size: 15px;
        }
        .i-title {
          font-size: 12px;
        }
        .i-price {
          font-size: 15px;
          color: @blue;
          img {
            width: 16px;
          }
        }
      }
    }
    .b-content {
      border-top: 1px solid #9f9f9f;
      padding: 0px 12px;
      .c-title {
        font-size: 14px;
        color: #999999;
        margin: 12px 0;
      }
      .c-options {
        .option-item {
          display: inline-block;
          border: 1px solid #9f9f9f;
          margin-bottom: 12px;
          margin-right: 6px;
          .o-title {
            font-size: 12px;
            padding: 4px 6px;
            color: @fontColor;
          }
          .o-img {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            font-size: 9px;
            text-align: center;
            img {
              height: 80px;
            }
          }
          &.active {
            border: 1px solid @blue;
            .o-title {
              color: @blue;
            }
          }
        }
      }
    }

    .input-div {
      position: relative;
      width: 90px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      border: 1px solid #8d8d8d;
      .decrease {
        width: 29px;
        height: 30px;
        position: absolute;
        left: 0px;
        top: 0px;
      }
      input {
        width: 30px;
        height: 28px;
        position: absolute;
        left: 30px;
        top: 0;
        border: none;
        padding: 0;
        text-align: center;
        border-left: 1px solid #8d8d8d;
        border-right: 1px solid #8d8d8d;
      }
      .increase {
        width: 29px;
        height: 30px;
        position: absolute;
        right: 0px;
        top: 0px;
      }
    }
    .b-btn {
      width: 160px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background-color: @blue;
      font-size: 16px;
      color: #ffffff;
      margin-left: 12px;
      margin: 50px 0 30px 12px;
    }
  }
}
.bg-gray {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 888;
}
</style>
<script>

import CommentComponent from "./common/CommentComponent";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import $sso from "../commons/utils/sso.js";
import LINKTYPE from "../commons/utils/linktype.js";
import pim from "../commons/utils/pim.js";

require("swiper/dist/css/swiper.css");
export default {
  data() {
    return {
      api: this.$store.state.api,
      BASE_URL: BASE_URL,
      token: localStorage.getItem('access_token'),
      eightD: this.$route.query.eightD,
      categoryCnName: "",
      categoryEnName: "",
      cnName: "",
      color: "",
      imagePath: "",
      price: "",
      srp: "",
      pts: "",
      memberpriceflag: "",
      storestatus: "",
      salestatus: "",
      cartpromotelist: [],
      promotelist: [],
      showInfo: "main",
      feature: "",
      mainSpec: [],
      swiperImgs: [],
      specifications: [],
      suit: [],
      foc: [],
      customizedLink: [],
      colorList: [],
      recommend: "",
      recommendList: [],
      averageRating: "",
      totalCount: "",
      reviews: [],
      showSelectBundle: false,
      isShowAddBasket: false,
      collapse: [{ collapsed: false }, { collapsed: false }],
      selectdBundle: {},
      quantity: 1,
      swiperOption: {
        notNextTick: true,
        autoplay: 3000,
        grabCursor: true,
        setWrapperSize: true,
        autoHeight: true,
        pagination: { el: ".swiper-pagination" },
        paginationClickable: true,
        scrollbar: ".swiper-scrollbar",
        mousewheelControl: true,
        observeParents: true,
        mouseWheel: true,
        click: true,
        tap: true
      }
    };
  },
  created() {
    this.login();
    this.getMasterData(this.eightD, false);
    this.getDetail();
    this.getReviews();
    this.getDetailSpec();
    //this.getProductAccessory();
  },
  watch: {
    $route(to, from) {
      this.eightD = this.$route.query.eightD;
      this.getMasterData(this.eightD, false);
      this.getDetail();
      this.getReviews();
      this.getDetailSpec();
    },
    selectdBundle(val){
    return
      let url = this.api.product.findMasterData();
      var dArr = val.eightd.split(",");
      console.log(dArr)
      for(let i =0;i<dArr.length;i++){
        if(dArr[i]!=this.eightD){
           this.$http
           .get(url, {
             params: {
               eightD: dArr[i]
             }
           })
           .then(res => {
             if (res.data.code == "00" && res.data.result) {
               let info = res.data.returnData.OutMasterData;
               this.colorList.push(info);

            }
          })
        }
      }
    }
  },
  computed: {

  },
  methods: {
  promotionTitle(_tit) {
      switch (_tit) {
        case 'ORDER_THRESHOLD_PROMO_CART':
          return '促销';
        case 'ORDER_THRESHOLD_PROMO_ALL':
          return '促销';
        case 'ORDER_THRESHOLD_PROMO_ANY':
          return '促销';
        case 'ORDER_THRESHOLD_PERCENTAGE_CART':
          return '满减';
        case 'ORDER_THRESHOLD_FIXED_DISCOUNT_CART':
          return '满减';
        case 'ORDER_THRESHOLD_PERCENTAGE_ALL':
          return '满减';
        case 'ORDER_THRESHOLD_FIXED_DISCOUNT_ALL':
          return '满减';
        case 'ORDER_THRESHOLD_PERCENTAGE_ANY':
          return '满减';
        case 'ORDER_THRESHOLD_FIXED_DISCOUNT_ANY':
          return '满减';
        case 'FOC_CART':
          return '满赠';
        default:
          return '促销'
          break;
      }
    },
    changeQuantity(_q) {
      if(_q>0&&_q<11) {
        this.quantity = _q;
      }
    },
    toggleCollapse(_i) {
      if (_i == "suit") {
        this.collapse[0].collapsed = !this.collapse[0].collapsed;
      } else if (_i == "foc") {
        this.collapse[1].collapsed = !this.collapse[1].collapsed;
      }
    },
    selectBundle() {
      this.showSelectBundle = !this.showSelectBundle;
    },
    ensureBundle() {
      this.showSelectBundle = false;
    },
    getBundle(_8d) {
      this.colorList = [];
      var dArr = _8d.split(",");
      this.eightD = dArr[0];
      for (var i = dArr.length - 1; i >= 0; i--) {
        this.getMasterData(dArr[i], false);
      }


      this.getDetail();
      this.getReviews();
      this.getDetailSpec();
    },
    getColor(_8d) {
      //this.colorList = [];
      this.eightD = _8d;
      this.getMasterData(_8d, true);

      this.getDetail();
      this.getReviews();
      this.getDetailSpec();
    },
    infinite(done) {
      if (this.showInfo != "main") {
        done();
        return;
      }
      console.log("infinite");
      this.showInfo = "feature";
      document.getElementsByClassName("_v-content")[0].style.transform =
        "translate3d(0px, 0px, 0px) scale(1)";
      done();
    },
    refresh(done) {
      console.log("refresh");
      this.showInfo = "main";
      done();
    },
    toggleInfo(info) {
      if (info == "compare") {
        this.$router.push({
          path: "/Compare",
          query: {
            eightD: this.eightD
          }
        });
      }
      this.showInfo = info;
      console.log(this.showInfo);
      document.getElementsByClassName("_v-content")[0].style.transform =
        "translate3d(0px, 0px, 0px) scale(1)";
    },
    getIframeHeight() {
      var featureHeight = document.documentElement.clientHeight;
      var iframeHeight = featureHeight - 140;
      document.getElementsByClassName("p-feature")[0].style.height =
        featureHeight + "px";
      document.getElementById("iframe").style.height = iframeHeight + "px";
    },

    ssologin() {
      // alert("Is Sony APP ");
      console.log("ssologin");
      $sso.login({ linkFrom: LINKTYPE.GOBACK });
    },

    login() {
      $sso.checkLogin();
    },
    getReviews() {
      let url = this.api.review.getProductReviews();
      this.$http
        .post(
          url,
          JSON.stringify({
            product8D: this.eightD
          })
        )
        .then(res => {
          if (
            res.data.resultMsg[0].code == "00" &&
            res.data.resultMsg[0].message == "Success"
          ) {
            var overallReviewStatus = res.data.resultData.overallReviewStatus;
            var reviews = res.data.resultData.reviews;

            if (overallReviewStatus) {
              this.averageRating = overallReviewStatus.averageRating;
              this.totalCount = overallReviewStatus.totalCount;
            }
            if (reviews) {
              this.reviews = reviews;
            }
          }
        });
    },
    async getMasterData(_8d, isColor) {
      var pd = await pim.getMasterWithPrice(_8d);

      if (pd && pd.sku8D) {
        if (!isColor) {
          this.colorList.push(pd);
        }

        this.cnName = pd.cnName;
        this.categoryCnName = pd.categoryCnName;
        this.categoryEnName = pd.categoryEnName;
        this.color = pd.color;
        this.imagePath = pd.imagePath;

        this.srp = pd.srp;
        this.price = pd.price;
        this.pts = pd.productprice.pts;
        this.memberpriceflag = pd.productprice.memberpriceflag;
        this.storestatus = pd.productprice.storestatus;
        this.salestatus = pd.productprice.salestatus;
        this.cartpromotelist = pd.cartpromotelist;
        this.promotelist = pd.promotelist;
      }
    },

    async getDetailSpec(){
      let spec = await pim.getMainSpec(this.eightD);
      if(spec.OutSkuDetailSpec && spec.OutSkuDetailSpec.specLevelOnes){
        this.mainSpec = spec.OutSkuDetailSpec.specLevelOnes;
      }
    },

    async getDetail() {
      let pd = await pim.getProductDetail(this.eightD);
      if (pd && pd.hasDetail) {
        //this.feature = pd.feature?pd.feature:'https://www.sonystyle.com.cn/products/nex/ilce_6000_app.htm';
        this.recommend = pd.recommend;
        if(this.recommend) {
          this.recommendList=[];
           var reArr = this.recommend.split(',');
           reArr.forEach(val=>{
              this.getRecommend(val);
           })
        }
        this.swiperImgs = pd.gallery.items;
        this.specifications = pd.specifications;
        this.suit = pd.suit;
        this.foc = pd.foc;
        this.customizedLink = pd.customizedLink;
        if (pd.currentBundle) {
          this.selectdBundle = pd.currentBundle;
        }

      }
    },
    async getRecommend(val) {
      let r =await pim.getMasterWithPrice(val);
      console.log(r)
      this.recommendList.push(r);
    },
    getProductAccessory() {
      let url = this.api.product.findProductAccessory();

      this.$http
        .get(url, {
          params: {
            eightD: this.eightD
          }
        })
        .then(res => {
          if (res.data.code == "00" && res.data.result) {
          }
        })
        .catch(res => {});
    },
    showAddBasket() {
      this.isShowAddBasket = !this.isShowAddBasket;
    },
    addBasket() {
      this.isShowAddBasket = false;
      var product = [
        {
          product8D: this.eightD,
          quantity: this.quantity,
          mainProduct: "Y",
          relationType: "",
          parent8D: ""
        }
      ];
      let url = this.api.basket.addToBasket(this);
      this.$http
        .post(
          url,
          JSON.stringify({
            products: product
          })
        )
        .then(res => {
          if (
            res.data.resultMsg[0].code == "00" &&
            res.data.resultMsg[0].message == "Success"
          ) {
            alert("加入成功");
          } else if (res.data.resultMsg[0].message) {
            alert(res.data.resultMsg[0].message);
          }
        })
        .catch(res => {});
    },
    addWishList() {
      let url = this.api.wishlist.addToWishList(this);
      this.$http
        .post(
          url,
          JSON.stringify({
            product8D: this.eightD
          })
        )
        .then(res => {
          if (
            res.data.resultMsg[0].code == "00" &&
            res.data.resultMsg[0].message == "Success"
          ) {
            alert("加入成功");
          } else if (res.data.resultMsg[0].message) {
            alert(res.data.resultMsg[0].message);
          }
        })
        .catch(res => {});
    },
    goCart() {
      this.$router.push({ path: "/ShopCart" });
    },
    goAllComment() {
      this.$router.push({
        path: "/AllComment",
        query: {
          eightD: this.eightD
        }
      });
    }
  },
  components: {
    swiper,
    swiperSlide,
    CommentComponent
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Product.vue